<h2 class="titulo-modal">
  <ng-content></ng-content>
</h2>
